import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { IEntityOwner } from 'app/models/licenses/entity-owner';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})

export class EntityOwnerService {
  private api: string = environment.privateApi + 'EntityOwner/';
  private http = inject(HttpClient);

  public getEntityOwners(entityId: number, entityType: string, includeArchived: boolean): Observable<IEntityOwner[]>{
    return this.http.get<IEntityOwner[]>(this.api + 'GetEntityOwners/' + entityId + '/' + entityType + '/' + includeArchived);
  }

  public createEntityOwner(owner: IEntityOwner, entityType: string): Observable<IEntityOwner>{
    return this.http.post<IEntityOwner>(this.api + 'CreateEntityOwner/' + entityType, owner);
  }

  public updateEntityOwner(owner: IEntityOwner): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateEntityOwner', owner);
  }

  public archiveEntityOwner(ownerId: number, archive: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveEntityOwner/' + ownerId + '/' + archive, null);
  }

  public deleteEntityOwner(ownerId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteEntityOwner/' + ownerId);
  }
}
